<template>
    <DeepiChip
        prependIcon="icon-status"
        :text="tr(`report.status.${props.status.toLowerCase().replace('_', '-')}` as any)"
        :color="color"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useTranslations } from '../../composables';
import { ReportStatus } from '../../models';

export interface ReportStatusChipProps {
    status: ReportStatus;
};

const props = defineProps<ReportStatusChipProps>();

const { tr } = useTranslations();

const color = computed((): 'edit' | 'error' | 'primary' | 'secondary' | 'success' | 'warning' => {
    switch (props.status) {
        case ReportStatus.CLOSED:
        case ReportStatus.PENDING:
            return 'secondary';
        case ReportStatus.IN_PROGRESS:
            return 'edit';
        case ReportStatus.NON_REPRODUCTIBLE:
            return 'error';
        case ReportStatus.RESOLVED:
            return 'success';
        default:
            return 'error';
    }
});
</script>